
interface DriverTabProps {
    tab: string;
    truckId: number;
}

const DriverTabData = (props: DriverTabProps) => {
    return (
        <div>
            <div className="bottom-nav">
                <a className="mobile-icon-white" href={"/driverjobs"}>
                    <span className="fas fa-list-alt mobileMenuSize alignIconCenter"></span>
                    <span>Jobs</span>
                </a>
                <a className="mobile-icon-white" href={"/driverteam/" + props.truckId}>
                    <span className="fas fa-users mobileMenuSize alignIconCenter"></span>
                    <span>Team</span>
                </a>
                <a className="mobile-icon-white" href={"/drivertruckcheck/" + props.truckId}>
                    <span className="fas fa-truck-moving mobileMenuSize alignIconCenter"></span>
                    <span>Truck Check</span>
                </a>
                <a className="mobile-icon-white" href={"/drivertoolcheck/" + props.truckId + "/1"}>
                    <span className="fas fa-screwdriver-wrench mobileMenuSize alignIconCenter"></span>
                    <span>Tool Check</span>
                </a>
                <a className="mobile-icon-white" href={"/drivertomorrowjobs/" + props.truckId}>
                    <i className="fa-solid fa-truck-arrow-right mobileMenuSize alignIconCenter"></i>
                    <span>Tomorrow</span>
                </a>
            </div>
        </div>
    );
}

export default DriverTabData;

